export function color32(r: number, g: number, b: number, a: number = 255) {
  return (((a & 255) << 24) | ((r & 255) << 16) | ((g & 255) << 8) | (b & 255)) >>> 0;
}

export function color32R(c: number) {
  return (c >>> 16) & 255;
}

export function color32G(c: number) {
  return (c >>> 8) & 255;
}

export function color32B(c: number) {
  return c & 255;
}

export function color32A(c: number) {
  return (c >>> 24) & 255;
}

export function setColorA(c: number, a: number) {
  return ((a << 24) | (c & 0x00ffffff)) >>> 0;
}

export function lerpColor(a: number, b: number, t: number) {
  const U = (t * 1024) | 0;
  const V = 1024 - U;
  return (
    ((((a >>> 24) * V + (b >>> 24) * U) >>> 10) << 24) |
    ((((255 & (a >>> 16)) * V + (255 & (b >>> 16)) * U) >>> 10) << 16) |
    ((((255 & (a >>> 8)) * V + (255 & (b >>> 8)) * U) >>> 10) << 8) |
    (((255 & a) * V + (255 & b) * U) >>> 10)
  );
}

export function multiplyAlpha(c: number, m: number) {
  return (((((c >>> 24) & 255) * m) << 24) | (c & 0x00ffffff)) >>> 0;
}

export function argbToCss(c: number) {
  return `rgba(${(c >>> 16) & 255},${(c >>> 8) & 255},${c & 0xff},${(((c >>> 24) & 255) / 255).toFixed(3)})`;
}

export function rgbToCss(c: number, a: number = 1) {
  return `rgba(${(c >>> 16) & 255},${(c >>> 8) & 255},${c & 255},${a})`;
}

export function parseCssHex(hex: string): number {
  const h = hex.startsWith("#") ? hex.slice(1) : hex;
  if (h.length === 3) {
    const r = parseInt(h[0], 16) * 17;
    const g = parseInt(h[1], 16) * 17;
    const b = parseInt(h[2], 16) * 17;
    return 0xff000000 | (r << 16) | (g << 8) | b;
  }
  return 0xff000000 | (parseInt(h, 16) << 0);
}
